export const STRUCTURE = {
  SCOPED: {
    new: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
      {
        accessorKey: "preliminary_staffing",
        displayName: "Preliminary Staffing",
        checked: true,
      },
    ],
    inprogress: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
      {
        accessorKey: "preliminary_staffing",
        displayName: "Preliminary Staffing",
        checked: true,
      },
    ],
    completed: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
      {
        accessorKey: "preliminary_staffing",
        displayName: "Preliminary Staffing",
        checked: true,
      },
    ],
  },
  INAB: {
    new: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "submitted_on",
        displayName: "Submitted Date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "inab_number", displayName: "Inab Number", checked: true },
    ],
    approved: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "submitted_on",
        displayName: "Submitted Date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "inab_number", displayName: "Inab Number", checked: true },
    ],
    completed: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "submitted_on",
        displayName: "Submitted Date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "inab_number", displayName: "Inab Number", checked: true },
    ],
    cancelledrejected: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "submitted_on",
        displayName: "Submitted Date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "inab_number", displayName: "Inab Number", checked: true },
    ],
    projectsinflight: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "project_end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "progress_percent",
        displayName: "Progress Percent",
        checked: true,
      },
      {
        accessorKey: "required_resources",
        displayName: "Required Resources",
        checked: true,
      },
      { accessorKey: "is_wavicle", displayName: "Is Wavicle", checked: true },
      { accessorKey: "rm_complete", displayName: "RM Complete", checked: true },
    ],
  },
  DEAL_REVIEW: {
    new: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
    inprogress: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
    reopen: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
    inreview: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
    approved: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
    legalpending: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
    completed: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
    ],
  },
  LEGAL_REVIEW: {
    new: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "deal_legal_id",
        displayName: "Deal Legal ID",
        checked: true,
      },
      { accessorKey: "draft_sow", displayName: "Draft SOW", checked: true },
      {
        accessorKey: "final_uploaded_sow_path",
        displayName: "Final Uploaded SOW Path",
        checked: true,
      },
      {
        accessorKey: "signed_sow_path",
        displayName: "Signed SOW Path",
        checked: true,
      },
    ],
    inreview: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "deal_legal_id",
        displayName: "Deal Legal ID",
        checked: true,
      },
      { accessorKey: "draft_sow", displayName: "Draft SOW", checked: true },
      {
        accessorKey: "final_uploaded_sow_path",
        displayName: "Final Uploaded SOW Path",
        checked: true,
      },
      {
        accessorKey: "signed_sow_path",
        displayName: "Signed SOW Path",
        checked: true,
      },
    ],
    inprogress: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "deal_legal_id",
        displayName: "Deal Legal ID",
        checked: true,
      },
      { accessorKey: "draft_sow", displayName: "Draft SOW", checked: true },
      {
        accessorKey: "final_uploaded_sow_path",
        displayName: "Final Uploaded SOW Path",
        checked: true,
      },
      {
        accessorKey: "signed_sow_path",
        displayName: "Signed SOW Path",
        checked: true,
      },
    ],
    completed: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        type: "date",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        type: "status",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "deal_legal_id",
        displayName: "Deal Legal ID",
        checked: true,
      },
      { accessorKey: "draft_sow", displayName: "Draft SOW", checked: true },
      {
        accessorKey: "final_uploaded_sow_path",
        displayName: "Final Uploaded SOW Path",
        checked: true,
      },
      {
        accessorKey: "signed_sow_path",
        displayName: "Signed SOW Path",
        checked: true,
      },
    ],
  },
  PLAY_GROUND: {
    all: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Client Name",
        checked: true,
      },
      { accessorKey: "sheet_count", displayName: "Sheet", checked: true },
      {
        accessorKey: "created_at",
        displayName: "Created At",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "last_sheet",
        displayName: "Updated At",
        checked: true,
        type: "date",
      },
      { accessorKey: "is_sharable", displayName: "Shared", checked: true },
      {
        accessorKey: "shared_users",
        displayName: "Shared User",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
    ],
  },
  PROJECT: {
    pendingprojects: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "project_end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "progress_percent",
        displayName: "Progress Percent",
        checked: true,
      },
      { accessorKey: "is_wavicle", displayName: "Is Wavicle", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "required_resources",
        displayName: "Required Resources",
        checked: true,
      },
    ],
    activeprojects: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "project_end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "progress_percent",
        displayName: "Progress Percent",
        checked: true,
      },
      { accessorKey: "is_wavicle", displayName: "Is Wavicle", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "required_resources",
        displayName: "Required Resources",
        checked: true,
      },
    ],
    completedprojects: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "project_end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "progress_percent",
        displayName: "Progress Percent",
        checked: true,
      },
      { accessorKey: "is_wavicle", displayName: "Is Wavicle", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "required_resources",
        displayName: "Required Resources",
        checked: true,
      },
    ],
    wavicleprojects: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "project_end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "progress_percent",
        displayName: "Progress Percent",
        checked: true,
      },
      { accessorKey: "is_wavicle", displayName: "Is Wavicle", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "required_resources",
        displayName: "Required Resources",
        checked: true,
      },
    ],
  },
  PEOPLE: {
    all: [
      { accessorKey: "employeeid", displayName: "Employee ID", checked: true },
      { accessorKey: "fullname", displayName: "Full Name", checked: true },
      { accessorKey: "work_email", displayName: "Work Email", checked: true },
      {
        accessorKey: "employee_location",
        displayName: "Employee Location",
        checked: true,
      },
      {
        accessorKey: "departmentname",
        displayName: "Department",
        checked: true,
      },
      { accessorKey: "rolename", displayName: "Role", checked: true },
      {
        accessorKey: "managername",
        displayName: "Manager/Mentor",
        checked: true,
      },
      {
        accessorKey: "employmenttype",
        displayName: "Employment Type",
        checked: true,
      },
      { accessorKey: "status_", displayName: "Status", checked: true },
      {
        accessorKey: "start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      { accessorKey: "total_yoe", displayName: "Total YOE", checked: true },
      { accessorKey: "wavicle_yoe", displayName: "Wavicle YOE", checked: true },
      {
        accessorKey: "yoe_before_wavicle",
        displayName: "YOE Before Wavicle",
        checked: true,
      },
      {
        accessorKey: "project_end_date",
        displayName: "Projected Roll Off Date",
        checked: true,
      },
      { accessorKey: "band_", displayName: "Band", checked: true },
      {
        accessorKey: "allocation_status",
        displayName: "Allocation Status",
        checked: true,
      },
      {
        accessorKey: "utilization_percentage",
        displayName: "Allocation%",
        checked: true,
      },
      { accessorKey: "category", displayName: "Category", checked: true },
      { accessorKey: "geography", displayName: "Geography", checked: true },
      {
        accessorKey: "certification",
        displayName: "Certification",
        checked: true,
      },
      {
        accessorKey: "domain_experience",
        displayName: "Domain Experience",
        checked: true,
      },
      { accessorKey: "mentor_id", displayName: "Mentor ID", checked: true },
      {
        accessorKey: "primary_skills",
        displayName: "Primary Skills",
        checked: true,
      },
      { accessorKey: "resume", displayName: "Resume", checked: true },
      {
        accessorKey: "secondary_skills",
        displayName: "Secondary Skills",
        checked: true,
      },
      { accessorKey: "profile_url", displayName: "Profile URL", checked: true },
      { accessorKey: "bench_notes", displayName: "Bench Notes", checked: true },
      {
        accessorKey: "probability_of_extention",
        displayName: "Probability of Extension",
        checked: true,
      },
      {
        accessorKey: "current_projects",
        displayName: "Current Projects",
        checked: true,
      },
      { accessorKey: "totalcount", displayName: "Total Count", checked: true },
    ],
  },
  DEMAND_PIPLINE: {
    preliminarystaffingdemand: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "action_type_name",
        displayName: "Action Type Name",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
      { accessorKey: "demand_id", displayName: "Demand ID", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "action_type_id",
        displayName: "Action Type ID",
        checked: true,
      },
      {
        accessorKey: "demand_type_id",
        displayName: "Demand Type ID",
        checked: true,
      },

      {
        accessorKey: "demand_type_name",
        displayName: "Demand Type Name",
        checked: true,
      },
      {
        accessorKey: "preliminary_staffing",
        displayName: "Preliminary Staffing",
        checked: true,
      },
    ],
    projectdemand: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
      { accessorKey: "demand_id", displayName: "Demand ID", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "action_type_id",
        displayName: "Action Type ID",
        checked: true,
      },
      {
        accessorKey: "demand_type_id",
        displayName: "Demand Type ID",
        checked: true,
      },
      {
        accessorKey: "action_type_name",
        displayName: "Action Type Name",
        checked: true,
      },
      {
        accessorKey: "demand_type_name",
        displayName: "Demand Type Name",
        checked: true,
      },
      {
        accessorKey: "preliminary_staffing",
        displayName: "Preliminary Staffing",
        checked: true,
      },
    ],
    otherdemand: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      {
        accessorKey: "company_name",
        displayName: "Company Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "created_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "hub_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "deal_id", displayName: "Deal ID", checked: true },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      {
        accessorKey: "preliminary_staffing",
        displayName: "Preliminary Staffing",
        checked: true,
      },
    ],
  },
  RESOURCE_ALLOCATION: {
    new: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "requested_resources",
        displayName: "Required Resources",
        checked: true,
      },
      {
        accessorKey: "demand_type",
        displayName: "Demand Type",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "rm_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "allocation_progress",
        displayName: "Allocation Progress",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      {
        accessorKey: "allocated_resources",
        displayName: "Allocated Resources",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "client_name", displayName: "Client Name", checked: true },
      {
        accessorKey: "role_allocation",
        displayName: "Role Allocation",
        checked: true,
      },
      { accessorKey: "demand_id", displayName: "Demand ID", checked: true },
      {
        accessorKey: "action_type_id",
        displayName: "Action Type ID",
        checked: true,
      },
      {
        accessorKey: "action_type_name",
        displayName: "Action Type Name",
        checked: true,
      },
      {
        accessorKey: "demand_type_id",
        displayName: "Demand Type ID",
        checked: true,
      },
    ],
    inprogress: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "requested_resources",
        displayName: "Required Resources",
        checked: true,
      },
      {
        accessorKey: "demand_type",
        displayName: "Demand Type",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "rm_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "allocation_progress",
        displayName: "Allocation Progress",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      {
        accessorKey: "allocated_resources",
        displayName: "Allocated Resources",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "client_name", displayName: "Client Name", checked: true },
      {
        accessorKey: "role_allocation",
        displayName: "Role Allocation",
        checked: true,
      },
      { accessorKey: "demand_id", displayName: "Demand ID", checked: true },
      {
        accessorKey: "action_type_id",
        displayName: "Action Type ID",
        checked: true,
      },
      {
        accessorKey: "action_type_name",
        displayName: "Action Type Name",
        checked: true,
      },
      {
        accessorKey: "demand_type_id",
        displayName: "Demand Type ID",
        checked: true,
      },
    ],
    partiallyallocated: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "requested_resources",
        displayName: "Required Resources",
        checked: true,
      },
      {
        accessorKey: "demand_type",
        displayName: "Demand Type",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "rm_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "allocation_progress",
        displayName: "Allocation Progress",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      {
        accessorKey: "allocated_resources",
        displayName: "Allocated Resources",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "client_name", displayName: "Client Name", checked: true },
      {
        accessorKey: "role_allocation",
        displayName: "Role Allocation",
        checked: true,
      },
      { accessorKey: "demand_id", displayName: "Demand ID", checked: true },
      {
        accessorKey: "action_type_id",
        displayName: "Action Type ID",
        checked: true,
      },
      {
        accessorKey: "action_type_name",
        displayName: "Action Type Name",
        checked: true,
      },
      {
        accessorKey: "demand_type_id",
        displayName: "Demand Type ID",
        checked: true,
      },
    ],
    complete: [
      {
        accessorKey: "project_name",
        displayName: "Project Name",
        checked: true,
      },
      { accessorKey: "deal_owner", displayName: "Deal Owner", checked: true },
      {
        accessorKey: "engagement_manager",
        displayName: "Engagement Manager",
        checked: true,
      },
      {
        accessorKey: "project_start_date",
        displayName: "Created Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "requested_resources",
        displayName: "Required Resources",
        checked: true,
      },
      {
        accessorKey: "demand_type",
        displayName: "Demand Type",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "rm_status",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "allocation_progress",
        displayName: "Allocation Progress",
        checked: true,
      },
      {
        accessorKey: "deal_review_id",
        displayName: "Deal Review ID",
        checked: true,
      },
      {
        accessorKey: "allocated_resources",
        displayName: "Allocated Resources",
        checked: true,
      },
      { accessorKey: "project_id", displayName: "Project ID", checked: true },
      { accessorKey: "client_name", displayName: "Client Name", checked: true },
      {
        accessorKey: "role_allocation",
        displayName: "Role Allocation",
        checked: true,
      },
      { accessorKey: "demand_id", displayName: "Demand ID", checked: true },
      {
        accessorKey: "action_type_id",
        displayName: "Action Type ID",
        checked: true,
      },
      {
        accessorKey: "action_type_name",
        displayName: "Action Type Name",
        checked: true,
      },
      {
        accessorKey: "demand_type_id",
        displayName: "Demand Type ID",
        checked: true,
      },
    ],
  },
  BENCH_FORCAST: {
    all: [
      { accessorKey: "geography", displayName: "Geography", checked: true },
      { accessorKey: "fullname", displayName: "Full Name", checked: true },
      { accessorKey: "band_", displayName: "Band", checked: true },
      {
        accessorKey: "utilization_percentage",
        displayName: "Allocation %",
        checked: true,
      },
      {
        accessorKey: "project_end_date",
        displayName: "Projected Roll Off Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "probability_of_extention",
        displayName: "Probability of Extension",
        checked: true,
      },
      { accessorKey: "employeeid", displayName: "Employee ID", checked: true },
      { accessorKey: "rolename", displayName: "Role Name", checked: true },
      {
        accessorKey: "departmentname",
        displayName: "Department Name",
        checked: true,
      },
      {
        accessorKey: "managername",
        displayName: "Manager Name",
        checked: true,
      },
      {
        accessorKey: "employmenttype",
        displayName: "Employment Type",
        checked: true,
      },
      {
        accessorKey: "status_",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "allocation_status",
        displayName: "Allocation Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "category", displayName: "Category", checked: true },
      {
        accessorKey: "certification",
        displayName: "Certifications",
        checked: true,
      },
      {
        accessorKey: "domain_experience",
        displayName: "Domain Experience",
        checked: true,
      },
      {
        accessorKey: "employee_location",
        displayName: "Employee Location",
        checked: true,
      },
      {
        accessorKey: "start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      {
        accessorKey: "end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      { accessorKey: "mentor_id", displayName: "Mentor ID", checked: true },
      {
        accessorKey: "primary_skills",
        displayName: "Primary Skills",
        checked: true,
      },
      {
        accessorKey: "secondary_skills",
        displayName: "Secondary Skills",
        checked: true,
      },
      { accessorKey: "resume", displayName: "Resume", checked: true },
      { accessorKey: "profile_url", displayName: "Profile URL", checked: true },
      { accessorKey: "wavicle_yoe", displayName: "Wavicle YOE", checked: true },
      {
        accessorKey: "total_yoe",
        displayName: "Total YOE",
        checked: true,
      },
      { accessorKey: "work_email", displayName: "Work Email", checked: true },
      {
        accessorKey: "yoe_before_wavicle",
        displayName: "YOE Before Wavicle",
        checked: true,
      },
      { accessorKey: "bench_notes", displayName: "Bench Notes", checked: true },

      {
        accessorKey: "current_projects",
        displayName: "Current Projects",
        checked: true,
      },
      { accessorKey: "totalcount", displayName: "Total Count", checked: true },
    ],
  },
  RM_SHEET: {
    all: [
      { accessorKey: "employeeid", displayName: "Employee ID", checked: true },
      { accessorKey: "fullname", displayName: "Full Name", checked: true },
      { accessorKey: "work_email", displayName: "Work Email", checked: true },
      {
        accessorKey: "employee_location",
        displayName: "Employee Location",
        checked: true,
      },
      {
        accessorKey: "departmentname",
        displayName: "Department",
        checked: true,
      },

      { accessorKey: "rolename", displayName: "Role", checked: true },
      {
        accessorKey: "managername",
        displayName: "Manager/Mentor",
        checked: true,
      },
      {
        accessorKey: "employmenttype",
        displayName: "Employment Type",
        checked: true,
      },
      {
        accessorKey: "status_",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },

      {
        accessorKey: "end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      { accessorKey: "total_yoe", displayName: "Total YOE", checked: true },
      { accessorKey: "wavicle_yoe", displayName: "Wavicle YOE", checked: true },
      {
        accessorKey: "yoe_before_wavicle",
        displayName: "YOE Before Wavicle",
        checked: true,
      },
      {
        accessorKey: "project_end_date",
        displayName: "Projected Roll Off Date",
        checked: true,
      },
      { accessorKey: "band_", displayName: "Band", checked: true },
      {
        accessorKey: "allocation_status",
        displayName: "Allocation Status",
        checked: true,
        type: "status",
      },
      {
        accessorKey: "utilization_percentage",
        displayName: "Allocation %",
        checked: true,
      },
      { accessorKey: "category", displayName: "Category", checked: true },
      { accessorKey: "geography", displayName: "Geography", checked: true },
      {
        accessorKey: "certification",
        displayName: "Certification",
        checked: true,
      },
      {
        accessorKey: "domain_experience",
        displayName: "Domain Experience",
        checked: true,
      },

      { accessorKey: "mentor_id", displayName: "Mentor ID", checked: true },
      {
        accessorKey: "primary_skills",
        displayName: "Primary Skills",
        checked: true,
      },
      { accessorKey: "resume", displayName: "Resume", checked: true },
      {
        accessorKey: "secondary_skills",
        displayName: "Secondary Skills",
        checked: true,
      },

      { accessorKey: "profile_url", displayName: "Profile URL", checked: true },

      { accessorKey: "bench_notes", displayName: "Bench Notes", checked: true },

      {
        accessorKey: "probability_of_extention",
        displayName: "Probability Of Extention",
        checked: true,
      },
      {
        accessorKey: "current_projects",
        displayName: "Current Projects",
        checked: true,
      },
      { accessorKey: "totalcount", displayName: "Total Count", checked: true },
    ],
  },
  DEMAND_RESOURCE: {
    all: [
      { accessorKey: "employeeid", displayName: "Employee ID", checked: true },
      { accessorKey: "fullname", displayName: "Full Name", checked: true },
      {
        accessorKey: "employee_location",
        displayName: "Employee Location",
        checked: true,
      },
      {
        accessorKey: "target_account",
        displayName: "Target Account",
        checked: true,
      },
      {
        accessorKey: "commit_status",
        displayName: "Commit Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "band_", displayName: "Band", checked: true },
      {
        accessorKey: "target_start_date",
        displayName: "Target Start Date",
        checked: true,
        type: "date",
      },
      { accessorKey: "commit_type", displayName: "Commit Type", checked: true },
      { accessorKey: "rolename", displayName: "Role Name", checked: true },
      {
        accessorKey: "departmentname",
        displayName: "Department Name",
        checked: true,
      },
      {
        accessorKey: "managername",
        displayName: "Manager Name",
        checked: true,
      },
      {
        accessorKey: "employmenttype",
        displayName: "Employment Type",
        checked: true,
      },
      {
        accessorKey: "status_",
        displayName: "Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "geography", displayName: "Geography", checked: true },
      {
        accessorKey: "allocation_status",
        displayName: "Allocation Status",
        checked: true,
        type: "status",
      },
      { accessorKey: "category", displayName: "Category", checked: true },
      {
        accessorKey: "certification",
        displayName: "Certification",
        checked: true,
      },
      {
        accessorKey: "domain_experience",
        displayName: "Domain Experience",
        checked: true,
      },

      {
        accessorKey: "end_date",
        displayName: "End Date",
        checked: true,
        type: "date",
      },
      { accessorKey: "mentor_id", displayName: "Mentor ID", checked: true },
      {
        accessorKey: "primary_skills",
        displayName: "Primary Skills",
        checked: true,
      },
      { accessorKey: "resume", displayName: "Resume", checked: true },
      {
        accessorKey: "secondary_skills",
        displayName: "Secondary Skills",
        checked: true,
      },
      {
        accessorKey: "start_date",
        displayName: "Start Date",
        checked: true,
        type: "date",
      },
      { accessorKey: "profile_url", displayName: "Profile URL", checked: true },
      { accessorKey: "wavicle_yoe", displayName: "Wavicle YOE", checked: true },
      { accessorKey: "total_yoe", displayName: "Total YOE", checked: true },
      { accessorKey: "work_email", displayName: "Work Email", checked: true },
      {
        accessorKey: "yoe_before_wavicle",
        displayName: "YOE Before Wavicle",
        checked: true,
      },
      { accessorKey: "bench_notes", displayName: "Bench Notes", checked: true },
      { accessorKey: "totalcount", displayName: "Total Count", checked: true },
    ],
  },
};
